import { render, staticRenderFns } from "./PostShow.vue?vue&type=template&id=b9a91812"
import script from "./PostShow.vue?vue&type=script&lang=js"
export * from "./PostShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports